<template>
  <div class="myorder">
    <div>
      <van-search
        v-model="blurry"
        placeholder="请输入保险名称、保险公司、投保人、被保人"
        background="#fff"
        @search="onSearch"
        shape="round"
      />
      <van-sticky>
        <van-tabs @click="onClick" style="padding: 10px 0; background: #fff">
          <van-tab title="全部" name=""></van-tab>
          <van-tab title="已承保" name="已承保"></van-tab>
          <van-tab title="退保" name="退保"></van-tab>
          <van-tab title="满期" name="满期"></van-tab>
        </van-tabs>
      </van-sticky>

      <van-empty description="暂无订单" v-if="list.length == 0" />
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        v-else
      >
        <div class="block" v-for="item in list" :key="item.policyId">
          <div class="title">
            {{ item.productName }}
          </div>
          <div class="flex jc-sb">
            <div>
              <div class="desc">保单号：{{ item.policyNo }}</div>
              <div class="desc">投保人：{{ item.holder.name }}</div>
              <div class="desc">被保险人：{{ item.insureds | getname }}</div>
              <div class="desc">保费：{{ item.premium }}元</div>
              <div class="desc">
                投保日期：{{ item.applyDate && item.applyDate.split(" ")[0] }}
              </div>
              <div class="desc">
                生效日期：{{
                  item.insBeginDate && item.insBeginDate.split(" ")[0]
                }}
              </div>
              <div class="desc" v-if="item.visit">
                回访时间：{{ item.visit.visitTime.split(" ")[0] }}
              </div>
            </div>
            <div
              class="logo"
              :class="{
                color2: item.status.indexOf('满期') != -1,
                color1: item.status.indexOf('已承保') != -1,
              }"
            >
              {{ item.detailStatus }}
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "@/components/produceFooter";
import { userinfo, queryAllByAgentIdOrBlurry } from "@/api/apis";
export default {
  components: {
    Footer,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 0,
      policyStatus: "",
      blurry: "",
      iscan: true,
    };
  },
  methods: {
    onClick(val) {
      console.log(val);
      this.policyStatus = val;
      this.page = 0;
      this.list = [];
      this.finished = false;
      this.onLoad();
    },
    onSearch() {
      this.page = 0;
      this.list = [];
      this.finished = false;
      this.onLoad();
    },
    onLoad() {
      if (!this.info || !this.info.employeeNumber) return;
      if (!this.iscan) return;
      let data = {
        agentId: this.info.employeeNumber,
        page: this.page,
        status: this.policyStatus,
        size: 10,
        blurry: this.blurry,
      };
      this.iscan = false;
      queryAllByAgentIdOrBlurry(data).then((res) => {
        this.iscan = true;
        if (this.list.length < res.totalElements) {
          this.list = this.list.concat(res.content);
          console.log(this.list);
          this.page++;
          this.loading = false;
          this.finished = false;
        } else {
          this.finished = true;
        }
      });
      //   setTimeout(() => {
      //     for (let i = 0; i < 10; i++) {
      //       this.list.push(this.list.length + 1);
      //     }

      //     // 加载状态结束
      //     this.loading = false;

      //     // 数据全部加载完成
      //     if (this.list.length >= 40) {
      //       this.finished = true;
      //     }
      //   }, 1000);
    },
    getinfo() {
      userinfo().then((res) => {
        this.info = res;
        this.onLoad();
      });
    },
    handler(e) {
      return e.preventDefault();
    },
  },
  mounted() {
    this.getinfo();
    // document.getElementsByTagName("body")[0].addEventListener("touchmove", this.handler, { passive: false });
  },
  filters: {
    getname(val) {
      let arr = val.map((item) => item.name);
      return arr.join("、");
    },
  },
};
</script>
<style lang="less" >
.myorder {
  width: 100%;
  // height: 100vh;
  padding-bottom: 130px;
  // padding-top: 50px;
  .block {
    left: 12px;
    top: 148px;
    width: 351px;
    min-height: 220px;
    line-height: 20px;
    border-radius: 10px;
    color: rgba(16, 16, 16, 100);
    font-size: 14px;
    text-align: center;
    box-shadow: 0px 0px 2px 0px rgba(151, 144, 144, 8);
    font-family: -apple-system;
    border: 1px solid rgba(255, 255, 255, 100);
    background: #fff;
    padding: 13px 14px;
    box-sizing: border-box;
    margin: 10px auto 0;
    .title {
      color: rgba(16, 16, 16, 100);
      font-size: 16px;
      line-height: 22px;
      text-align: left;
      font-family: PingFangSC-bold;
      border-bottom: 1px solid rgba(246, 246, 246, 100);
      padding-bottom: 7px;
      font-weight: 500;
    }
    .desc {
      height: 17px;
      color: rgba(143, 147, 154, 100);
      font-size: 12px;
      text-align: left;
      line-height: 17px;
      margin-top: 9px;
    }
    .logo {
      font-size: 12px;
      text-align: left;
      color: rgba(151, 144, 144, 100);
      margin-top: 9px;
    }
    .color1 {
      color: #34a7f4;
    }
    .color2 {
      color: #ff5f11 !important;
    }
  }
  .van-tab--active {
    color: #34a7f4 !important;
    font-size: 14px;
    // font-weight: 500;
  }
  .van-tab {
    font-size: 14px;
    color: #666666;
  }
  .van-tabs__line {
    height: 2px;
    background-color: #34a7f4;
  }
}
</style>